<mat-sidenav #sidenav mode="push" class="app-sidenav">
  <mat-toolbar color="primary">
    <!--future svg to go here-->
    <span class="toolbar-filler"></span>
    <button mat-icon-button (click)="sidenav.toggle()" class="sidenav-toggle-button"
      [hidden]="!sidenav.opened">
      <mat-icon aria-label="Menu" class="material-icons">close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-nav-list>
    <a mat-list-item class="sidenav-link" (click)="sidenav.toggle();logout(); ">
      <mat-icon mat-list-icon>account_balance</mat-icon>
      <span class="title" mat-line>{{ 'menu.logout' | translate }}</span>
      <span mat-line class="secondary">{{ 'menu.logout.description' | translate }}</span>
    </a>
    <a mat-list-item class="sidenav-link" [routerLink]="['/users']" (click)="sidenav.toggle()">
      <mat-icon mat-list-icon>android</mat-icon>
      <span class="title" mat-line>{{ 'menu.users' | translate }}</span>
      <span mat-line class="secondary">{{ 'menu.users.description' | translate }}</span>
    </a>
  </mat-nav-list>
</mat-sidenav>
<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button mat-icon-button (click)="sidenav.toggle()" class="sidenav-toggle-button"
      [hidden]="sidenav.opened">
      <mat-icon aria-label="Another menuTODO" class="material-icons">menu</mat-icon>
    </button>
    <span class="title">{{ 'app.title' | translate }}</span>
    <span class="fill-remaining-space"></span>
    <app-settings></app-settings>
    <app-settings-reset></app-settings-reset>
    <app-theme></app-theme>
  </mat-toolbar-row>
  <mat-toolbar-row>
    <span class="fill-remaining-space"></span>
    <button mat-button routerLink="/soundtracks" matTooltip="{{ 'header.soundtrack' | translate }}"><mat-icon mat-list-icon>music_note</mat-icon></button>
    <button mat-button routerLink="/devices" matTooltip="{{ 'header.device' | translate }}"><mat-icon mat-list-icon>keyboard</mat-icon></button>
  </mat-toolbar-row>
</mat-toolbar>